import { render, staticRenderFns } from "./CmgInlineLoader.vue?vue&type=template&id=7ae91f52&scoped=true&lang=pug"
import script from "./cmg-inline-loader.ts?vue&type=script&lang=ts&external"
export * from "./cmg-inline-loader.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgInlineLoader.vue?vue&type=style&index=0&id=7ae91f52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae91f52",
  null
  
)

export default component.exports